import { logWarning } from 'client/javascript/util/logger';
import { sendBucketEvent } from 'client/javascript/heap';
import { getExperimentValue, DEFAULT_CONTROL_VALUE, DEFAULT_VARIANT_VALUE } from 'client/javascript/experiments';

const ELIGIBLE_EXPERIMENT_VALUES = [DEFAULT_CONTROL_VALUE, DEFAULT_VARIANT_VALUE];

export function setupHomepageBrowseByWorkspaceExperimentBucketing() {
  try {
    const shouldBucket = ELIGIBLE_EXPERIMENT_VALUES.includes(getExperimentValue('homepage_browse_by_workspace_test'));

    if (shouldBucket) {
      sendBucketEvent('homepage_browse_by_workspace_test');
    }
  } catch (error) {
    logWarning(`[Home page] Browse by Workspace bucketing event failed: ${error.message}`, error);
  }
}
